export default "__VITE_ASSET__DX6c$m1b__"